import React, { useState, useEffect, useContext, useRef } from "react";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Checkbox,
  Button,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import ListSubheader from "@mui/material/ListSubheader";
import Radio from "@mui/material/Radio";
import { useForm, Controller } from "react-hook-form";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import {
  useQuery,
  useManualQuery,
  useMutation,
  ClientContext,
} from "graphql-hooks";

import { MEMBER_TERM_ATTENDANCE_LIST } from "../../graphQL/member";
import { GET_CLIENT_UUID } from "../../graphQL/client_qry";
import { project_url } from "../../constants/Data";

var findAnd = require("find-and");

const useStyles = makeStyles((theme) => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    marginTop: 30,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14,
    fontFamily: "Arial",
  },
  selectStyle: {
    minWidth: 250,
    height: 35,
    //  paddingLeft: 16,
    marginBottom: 25,
    "& .MuiOutlinedInput-input": {
      textAlign: "left",
    },
  },
  dataGridStyle: {
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#99D4FF",
      color: "#0D47A1",
    },

    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "&.MuiDataGrid-root": {
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 14,
    },
  },
}));

export default function MemberAttendanceInfoDialog({
  closeDialog,
  termUuid,
  termName,
  termTeams,
  columns,
  memberAttendanceData,
}) {
  let termsList = [];
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [loadData, setLoadData] = useState(false);
  const [eventsList, setEventsList] = useState([]);
  const [alertMsg, setAlertMsg] = useState([]);
  const [selectedVal, setSelectedVal] = useState("Select");
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Set time to 00:00:00 to compare only the date part
  let clientId = 1;
  if (localStorage.getItem("clientId"))
    clientId = localStorage.getItem("clientId");
  let clientName = "";
  if (localStorage.getItem("clientName"))
    clientName = localStorage.getItem("clientName");
  let tenantId = 1;
  if (localStorage.getItem("tenantId"))
    tenantId = localStorage.getItem("tenantId");

  const [getMemberTermAttendanceQuery] = useManualQuery(
    MEMBER_TERM_ATTENDANCE_LIST
  );

  const handleChangeValue = async (event) => {
    const data = event.target.value;
    setRows(data ? data.getMemberTermAttendance : []);
  };
  //   const {
  //     loading: loadingData,
  //     error: errorData,
  //     data: dataList,
  //   } = await getMemberTermAttendanceQuery({
  //     variables: {
  //       teamTermMemberId: parseInt(event.target.value),
  //     },
  //   });
  //
  //   if (!loadingData && dataList) {
  //     let tmp = [];
  //     console.log(dataList);
  //     for (var i in dataList.getMemberTermAttendance) {
  //       let attendance = dataList.getMemberTermAttendance[i];
  //       let data = {};
  //       data["id"] = attendance.teamTermEventId.teamTermEventId;
  //       data["period"] = attendance.teamTermEventId.teamTermPeriodId.name;
  //       data["event"] = attendance.teamTermEventId.name;
  //       data["desc"] = attendance.teamTermEventId.desc;
  //       data["actualDate"] = dayFormat(attendance.teamTermEventId.actualDate);
  //       data["scheduledDate"] = dayFormat(
  //         attendance.teamTermEventId.scheduledDate
  //       );
  //       data["eventType"] = attendance.teamTermEventId.eventTypeId.name;
  //       data["attended"] = attendance.attended === true ? "Yes" : "No";
  //       tmp.push(data);
  //     }
  //     setEventsList(tmp);
  //     console.log(tmp);
  //     setLoadData(true);
  //   }
  //   if (errorData) {
  //     console.log(errorData);
  //     if (errorData.graphQLErrors[0].message === "Signature has expired")
  //       navigate(`${project_url}/signin/?next=${pathname}`);
  //   }
  // };

  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };
  const dayFormat = (day) => {
    let newFormat = "-";
    if (day) {
      const dayDate = new Date(day);
      const dayFormat = formatter.formatToParts(dayDate);
      newFormat =
        dayFormat.find((a) => a.type == "month").value +
        "/" +
        dayFormat.find((a) => a.type == "day").value +
        "/" +
        dayFormat.find((a) => a.type == "year").value;
    }
    return newFormat;
  };

  useEffect(() => {
    handleChangeValue({ target: { value: memberAttendanceData.members[0] } });
  }, [termTeams, memberAttendanceData]);

  const formatter = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  function CustomNoRowsOverlay() {
    return (
      <Box sx={{ mt: 2 }}>
        There is no event that requires any member's attendance
      </Box>
    );
  }

  // const rows = eventsList.map((trm, index) => ({
  //   index,
  //   id: trm.id,
  //   period: trm.period,
  //   event: trm.event,
  //   eventType: trm.eventType,
  //   desc: trm.desc,
  //   scheduledDate: trm.scheduledDate,
  //   actualDate: trm.actualDate,
  //   attended: trm.attended,
  // }));

  return (
    <div>
      <Dialog
        disablePortal
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "1100px",
              height: "700px",
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Box mt={1} ml={1}>
            Resources Attendance
          </Box>
          {closeDialog ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                align: "right",
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="h3"
            style={{ fontSize: 16, textAlign: "left", marginBottom: 5 }}
          >
            <b>Term:</b> {termName}
          </Typography>

          <Typography
            variant="h3"
            style={{ fontSize: 16, textAlign: "left", marginBottom: 5 }}
          >
            <b>Team: </b> {termTeams}
          </Typography>
          <Box style={{ display: "flex", flexDirection: "row" }}>
            <Typography
              variant="h3"
              style={{
                fontSize: 16,
                textAlign: "left",
                marginBottom: 5,
                paddingTop: 5,
              }}
            >
              <b>Resources:</b>
            </Typography>
            <Box pl={1}>
              <Select
                className={classes.selectStyle}
                defaultValue={memberAttendanceData.members[0]}
                margin="normal"
                onChange={handleChangeValue}
              >
                <ListSubheader>
                  <Typography
                    variant="h3"
                    style={{
                      fontSize: 17,
                      fontWeight: 700,
                      paddingBottom:10
                    }}
                  >
                    Members:
                  </Typography>
                </ListSubheader>
                {memberAttendanceData.members.map((member, index) => (
                  <MenuItem key={index} value={member}>
                    {member.name}
                  </MenuItem>
                ))}
                <ListSubheader>
                  <Typography
                    variant="h3"
                    style={{
                      fontSize: 17,
                      fontWeight: 700,
                      paddingBottom:10,
                      paddingTop:10
                    }}
                  >
                    Staff:
                  </Typography>
                </ListSubheader>
                {memberAttendanceData.staff.map((staff, index) => (
                  <MenuItem key={index} value={staff}>
                    {staff.name}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </Box>
          <DataGrid
            className={classes.dataGridStyle}
            columns={columns}
            rows={rows}
            showCellRightBorder={true}
            hideFooter={true}
            autoWidth={true}
            slots={{
              noRowsOverlay: CustomNoRowsOverlay,
            }}
            getRowId={(row) => row.id}
            getRowClassName={(params) => {
              if (params.row.index % 2 === 0) return "even";
              else return "odd";
            }}
            autoHeight={true}
            experimentalFeatures={{ newEditingApi: true }}
          />
          {errorMsg.form && (
            <Box pt={1}>
              <FormHelperText className={classes.errorStyle} error>
                {errorMsg.form}
              </FormHelperText>
            </Box>
          )}
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Box mb={2}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              style={{ marginRight: 2 }}
              onClick={handleClose}
            >
              Done
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
